import { api } from "@/lib/api";
import type { PharmacyPurchaseOrder } from "@/api/pharmacyPurchase";

const base = "/api/pharma-vendor-portal";

export type VendorDeliveryLineInput = {
  drugId: string;
  batchNo: string;
  expiryDate: string;
  quantity: number;
  mrp: number;
  purchaseRate: number;
  gstRate?: number | null;
  discountRate?: number | null;
  notes?: string | null;
};

export const pharmaVendorPortalApi = {
  me: () => api.get(`${base}/me`),
  listOrders: () => api.get(`${base}/orders`),
  getOrder: (orderId: string) => api.get(`${base}/orders/${orderId}`),
  saveDelivery: (
    orderId: string,
    body: {
      invoiceNumber: string;
      invoiceDate: string;
      totalAmount?: number;
      notes?: string;
      lines: VendorDeliveryLineInput[];
      submit?: boolean;
    }
  ) => {
    const fd = new FormData();
    fd.append("invoiceNumber", body.invoiceNumber);
    fd.append("invoiceDate", body.invoiceDate);
    if (body.totalAmount != null) fd.append("totalAmount", String(body.totalAmount));
    if (body.notes) fd.append("notes", body.notes);
    fd.append("lines", JSON.stringify(body.lines));
    fd.append("submit", body.submit ? "true" : "false");
    return api.post(`${base}/orders/${orderId}/delivery`, fd);
  },
  uploadInvoiceFile: (orderId: string, file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`${base}/orders/${orderId}/invoice-file`, fd);
  },
};

export type { PharmacyPurchaseOrder };
